'use strict';
import { getCookie, removeCookie } from "../utils/cookie-handler";

const JS_CLASSES = {
    'subscriptionBar': '.js-subscription-bar',
    'barExitBtn': '.js-subscription-bar-exit',
    'barGoBackBtn': '.js-subscription-bar-goback',
    'barExitAnchor': '.js-subscription-bar-exit-anchor',
    'barReturnAnchor': '.js-subcription-bar-returnurl'
}

const _BO_COOKIE = '_bo_change_sub';

export function init() {
    const bar = document.querySelector(JS_CLASSES.subscriptionBar);
    if (!bar) return;

    const returnPath = getCookie(_BO_COOKIE);
    if (!returnPath) return;

    bar.classList.remove('page-subscription-bar--hidden');

    const exitBtn = bar.querySelector(JS_CLASSES.barExitBtn);
    const goBackBtn = bar.querySelector(JS_CLASSES.barGoBackBtn);
    const exitAnchor = bar.querySelector(JS_CLASSES.barExitAnchor);
    const returnAnchor = bar.querySelector(JS_CLASSES.barReturnAnchor);

    if (returnAnchor) {
        returnAnchor.addEventListener('click', function () {
            removeCookie(_BO_COOKIE);
        });

        returnAnchor.href = `${AppConfig.boDomain}${returnPath.replace('/', '')}`;
    }

    if (exitBtn) {
        exitBtn.addEventListener('click', function () {
            bar.classList.add('page-subscription-bar--alert');
        });
    }

    if (goBackBtn) {
        goBackBtn.addEventListener('click', function () {
            bar.classList.remove('page-subscription-bar--alert');
        });
    }

    if (exitAnchor) {
        exitAnchor.addEventListener('click', function () {
            removeCookie(_BO_COOKIE);
            bar.classList.add('page-subscription-bar--hidden');
        });
    }
}
